<template>
  <div>
    <div class="titles">
      添加权限
      <Icon type="ios-redo" size="25" class="auth01" @click="back"/>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">名称：</div>
        <Input v-model="name" placeholder="请输入顶级权限名称..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">顺序：</div>
        <Input v-model="order" placeholder="请输入顶级权限顺序..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">地址：</div>
        <Input v-model="url" placeholder="请输入子级跳转地址..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">类型：</div>
        <Select v-model="auth_type" style="width: 300px;height: 60px !important;">
          <Option value="0">菜单类型</Option>
          <Option value="1">按钮类型</Option>
        </Select>
      </div>
    </div>
    <div style="width: 100%;display: flex;justify-content: center">
      <Button :loading="loading" type="success" class="qx09" @click="addAuth" v-on:keyup.13="addAuth()">提交</Button>
    </div>
  </div>
</template>

<script>
  import httpAuth from '@/api/auth';
  export default {
    name: "AddZjAuth",
    data(){
      return{
        name:'',        //权限名称
        order:'',       //权限顺序
        auth_type:'',   //权限类型
        url:'',         //权限地址
        pid:'',         //父级ID
        id:'',          //修改ID
        loading:false,  //是否加载
      }
    },
    created() {
      var lett = this;
      if (lett.$route.params.hasOwnProperty('pid')) {
        lett.pid = lett.$route.params.pid;
      }
      if (lett.$route.params.hasOwnProperty('id')) {
        lett.id = lett.$route.params.id;
        lett.name = lett.$route.params.name;
        lett.order = lett.$route.params.order;
        lett.url = lett.$route.params.url;
        lett.auth_type = ''+lett.$route.params.types+'';
      }
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          lett.addAuth();
        }
      }
    },
    mounted() {
    },
    methods:{
      back(){
        var me = this;
        me.$router.back();
      },
      addAuth(){//添加权限
        var me = this;
        if (me.name === '') {
          me.$message.error('请输入权限名称');
          return false;
        }
        if (me.order === '') {
          me.$message.error('请输入权限顺序');
          return false;
        }
        if (me.url === '') {
          me.$message.error('请输入权限地址');
          return false;
        }
        if (me.auth_type === '') {
          me.$message.error('请选择权限类型');
          return false;
        }
        let user = JSON.parse(sessionStorage.getItem('user'));
        //添加权限
        let data = {
          name: me.name,
          code: me.order,
          type: me.auth_type,
          url: me.url,
          userId: user.id,
          sign: user.sign,
          mobile:user.mobile,
        }
        if (me.id !== '') {
          data['id'] = me.id;
        }
        if (me.pid !== '') {
          data['pid'] = me.pid;
        }
        me.loading = true;
        httpAuth.editAuthName(data).then(res => {
          if (res.code != "1111") {
            me.loading = false;
            me.$message.success('编辑成功');
            setTimeout(function () {
              me.$router.back();
            },1500)
          } else {
            me.$message.error('系统错误');
          }
        })
      }
    }
  }
</script>

<style scoped>
  @import "AuthList.css";
</style>
